import React,{useEffect} from "react";
import AppRouter from "./Approutes";
import WhatsAppFab from "./Components/Common/WhatsAppFab/WhatsAppFab";
function App() {
  useEffect(()=>{
    document.documentElement.scrollTo({
      top: 0,
      left: 0
    })
  },[])

  const isAdminPreview =
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/admin-preview/');

  return (
    <>
      <AppRouter/>
      {!isAdminPreview && <WhatsAppFab/>}
    </>
  );
}

export default App;
